import React from "react";

import { useOktaAuth } from "@okta/okta-react";

const LoginCallBack = () => {
  const { authState, oktaAuth } = useOktaAuth();
  React.useEffect(() => {
    const fetchAccessToken = async () => {
      try {
        const accessToken = await oktaAuth.tokenManager.get("accessToken");
      } catch (err) {
        console.error("Error getting access token", err);
      }
    };

    fetchAccessToken();
  }, [oktaAuth]);

  return (
    <>
      <div></div>
    </>
  );
};

export default LoginCallBack;
